module.exports = __webpack_public_path__ + "img/IT0000104617709.b3f701b8.png";